import { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#2541a3", "#2f66d0", "#2aa9e0", "#5bc8e8", "#c2178c", "#d63384"];

function mulberry32(seed) {
  return () => {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export default function PixelField() {
  const pixels = useMemo(() => {
    const rand = mulberry32(42);
    return Array.from({ length: 56 }, (_, i) => ({
      id: i,
      x: rand() * 100,
      y: rand() * 100,
      s: 3 + Math.round(rand() * 8),
      c: COLORS[Math.floor(rand() * COLORS.length)],
      delay: rand() * 7,
      dur: 5 + rand() * 8,
      driftX: (rand() - 0.5) * 60,
      driftY: (rand() - 0.5) * 44,
      rot: (rand() - 0.5) * 50,
      maxOpacity: 0.25 + rand() * 0.55,
    }));
  }, []);

  return (
    <div data-testid="pixel-field" className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {pixels.map((p) => (
        <motion.span
          key={p.id}
          className="absolute rounded-[2px]"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.s,
            height: p.s,
            backgroundColor: p.c,
            boxShadow: `0 0 ${p.s * 2}px ${p.c}66`,
          }}
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0, p.maxOpacity, p.maxOpacity * 0.35, p.maxOpacity, 0],
            x: [0, p.driftX, -p.driftX * 0.6, 0],
            y: [0, p.driftY, -p.driftY * 0.5, 0],
            rotate: [0, p.rot, -p.rot * 0.5, 0],
          }}
          transition={{
            duration: p.dur,
            repeat: Infinity,
            delay: p.delay,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
}
